import { Plus, Check, Info } from "lucide-react";
import { useOffer } from "@/context/OfferContext";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

/**
 * A-grade ("LIDAR") rule: only machines with a transparent, non-request price can be
 * added to the tender offer basket. Machines priced "on request" show an inactive
 * button that explains they require individual engineering consultation.
 */
export default function OfferButton({ product, size = "sm", className = "" }) {
  const { has, toggle } = useOffer();
  const { t } = useTranslation();
  const onRequest = product.price_on_request || !product.price;
  const inOffer = has(product.id);
  const pad = size === "lg" ? "px-5 py-3.5 text-xs" : "px-3 py-2 text-[11px]";
  const base = `w-full inline-flex items-center justify-center gap-1.5 font-bold uppercase tracking-wide border transition-colors ${pad} ${className}`;

  if (onRequest) {
    return (
      <button type="button" onClick={() => toast.info(t("offer.requiresConsult"))}
        title={t("offer.requiresConsult")}
        className={`${base} border-slate-200 bg-slate-50 text-slate-400 cursor-not-allowed`}
        data-testid={`offer-add-${product.id}`}>
        <Info className="w-3.5 h-3.5" /> {t("offer.consultShort")}
      </button>
    );
  }
  return (
    <button type="button" onClick={() => toggle(product)}
      className={`${base} ${inOffer ? "bg-emerald-600 border-emerald-600 text-white hover:bg-emerald-700" : "bg-white border-slate-300 text-slate-700 hover:border-orange-500 hover:text-orange-600"}`}
      data-testid={`offer-add-${product.id}`}>
      {inOffer ? <><Check className="w-3.5 h-3.5" /> {t("offer.added")}</> : <><Plus className="w-3.5 h-3.5" /> {t("offer.add")}</>}
    </button>
  );
}
